import { Building, User } from 'lucide-react';
import { cn } from '@/app/lib/utils';
import Pill from '../ui/Pill';
import Tooltip from '../ui/Tooltip';

type QualificationPillProps = {
  type: 'persona' | 'icp';
  label: string;
  reason?: string;
  className?: string;
  tooltipSide?: 'top' | 'right' | 'bottom' | 'left';
};

export default function QualificationPill({
  type,
  label,
  reason,
  className,
  tooltipSide = 'right',
}: QualificationPillProps) {
  const isPersona = type === 'persona';
  const pill = (
    <Pill
      variant="outline"
      color={isPersona ? 'sky' : 'success'}
      rounded={false}
      icon={
        isPersona ? <User size={12} strokeWidth={1.5} /> : <Building size={12} strokeWidth={1.5} />
      }
      className={cn('min-w-0 max-w-full uppercase', className)}
    >
      <span className="min-w-0 truncate">{label}</span>
    </Pill>
  );

  if (!reason) return pill;

  return (
    <Tooltip
      label={reason}
      side={tooltipSide}
      sideOffset={0}
      delayDuration={0}
      className={`max-w-[300px] rounded-[6px] px-3 py-1.5 text-xs text-white ${
        isPersona ? 'bg-sky-600' : 'bg-success'
      }`}
      arrowClassName={isPersona ? 'fill-sky-600' : 'fill-success'}
    >
      <span className="inline-flex min-w-0 max-w-full">{pill}</span>
    </Tooltip>
  );
}
